import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SportOfficialsIndexTable from './SportOfficialsIndexTable';

function SportOfficialsIndex(props) {
    const [nationalities, setNationalities] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        fetchNationalities();
    }, []);

    const fetchNationalities = () => {
        setError('');

        axios
            .get(sportOfficialsCreateUrl)
            .then((response) => {
                const nationalitiesObjects = response.data.nationalities.map((nationality) => {
                    return { value: nationality.nationality, label: nationality.nationality };
                });
                setNationalities([{ value: '', label: $t('Undisclosed') }, ...nationalitiesObjects]);
            })
            .catch((e) => {
                setError('There was an error fetching Nationalities');
            });
    };

    return error !== '' ? (
        <div className="alert alert-danger">
            <ul>
                <li>{error}</li>
            </ul>
        </div>
    ) : (
        <div>
            <div className="row p-2">
                <div className="col">
                    <ul className="nav nav-tabs border-0 font-weight-600 nav-tabs-style-1" id="officialsListTab" role="tablist">
                        <li className="nav-item px-2" role="presentation">
                            <button
                                className="nav-link active bg-transparent font-weight-bold border-0 mr-2 px-2 py-1"
                                id="td-list-tab"
                                data-toggle="tab"
                                data-target="#td-list"
                                type="button"
                                role="tab"
                                aria-controls="td-list"
                                aria-selected="true"
                            >
                                {$t('TD')}
                            </button>
                        </li>
                        <li className="nav-item px-2" role="presentation">
                            <button
                                className="nav-link bg-transparent font-weight-bold border-0 mr-2 px-2 py-1"
                                id="ito-list-tab"
                                data-toggle="tab"
                                data-target="#ito-list"
                                type="button"
                                role="tab"
                                aria-controls="ito-list"
                                aria-selected="true"
                            >
                                {$t('ITO')}
                            </button>
                        </li>
                        <li className="nav-item px-2" role="presentation">
                            <button
                                className="nav-link bg-transparent font-weight-bold border-0 mr-2 px-2 py-1"
                                id="nto-list-tab"
                                data-toggle="tab"
                                data-target="#nto-list"
                                type="button"
                                role="tab"
                                aria-controls="nto-list"
                                aria-selected="true"
                            >
                                {$t('NTO')}
                            </button>
                        </li>
                    </ul>

                    <div className="tab-content" id="officialsListContent">
                        <div className="tab-pane fade show active border-0" id="td-list" role="tabpanel" aria-labelledby="td-list-tab">
                            <SportOfficialsIndexTable
                                officialRole="TD"
                                nationalities={nationalities}
                                sportOfficialsIndexUrl={sportOfficialsIndexUrl}
                                sportOfficialsStoreUrl={sportOfficialsStoreUrl}
                                sportOfficialsUpdateUrl={sportOfficialsUpdateUrl}
                                sportOfficialsDeleteUrl={sportOfficialsDeleteUrl}
                                arrivalDate={sportOfficialsTDArrivalDate}
                                departureDate={sportOfficialsTDDepartureDate}
                            />
                        </div>
                        <div className="tab-pane fade show border-0" id="ito-list" role="tabpanel" aria-labelledby="ito-list-tab">
                            <SportOfficialsIndexTable
                                officialRole="ITO"
                                nationalities={nationalities}
                                sportOfficialsIndexUrl={sportOfficialsIndexUrl}
                                sportOfficialsStoreUrl={sportOfficialsStoreUrl}
                                sportOfficialsUpdateUrl={sportOfficialsUpdateUrl}
                                sportOfficialsDeleteUrl={sportOfficialsDeleteUrl}
                                arrivalDate={sportOfficialsITOArrivalDate}
                                departureDate={sportOfficialsITODepartureDate}
                            />
                        </div>
                        <div className="tab-pane fade show border-0" id="nto-list" role="tabpanel" aria-labelledby="nto-list-tab">
                            <SportOfficialsIndexTable
                                officialRole="NTO"
                                nationalities={nationalities}
                                sportOfficialsIndexUrl={sportOfficialsIndexUrl}
                                sportOfficialsStoreUrl={sportOfficialsStoreUrl}
                                sportOfficialsUpdateUrl={sportOfficialsUpdateUrl}
                                sportOfficialsDeleteUrl={sportOfficialsDeleteUrl}
                                arrivalDate={sportOfficialsNTOArrivalDate}
                                departureDate={sportOfficialsNTODepartureDate}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SportOfficialsIndex;
if (document.getElementById('SportOfficialsIndex')) {
    var rootEl = document.getElementById('SportOfficialsIndex');
    ReactDOM.render(
        <App>
            <SportOfficialsIndex />
        </App>,
        rootEl,
    );
}
